import { type FC } from "react";
import { StepSection } from "@components/StepSection";
import styles from "./PrescriptionStep.module.css";
import { useStoreActions } from "@/store";
import { useWorkflow } from "@/hooks";
import { useTranslation } from "@/i18n";
import { StepTitleDescription } from "@/components/StepTitleDescritpion";
import StepCard from "@/components/StepCard";

interface PrescriptionStepProps {
  title: string;
  description?: string;
}

export const PrescriptionStep: FC<PrescriptionStepProps> = ({
  title,
  description,
}) => {
  const { setManualInput } = useStoreActions();
  const { handleNext } = useWorkflow();
  const { t } = useTranslation();

  const handleManualInput = () => {
    setManualInput(true);
    handleNext();
  };
  const handleFromAccount = () => {
    setManualInput(false);
    handleNext();
  };

  return (
    <StepSection>
      <div className={styles.container}>
        <StepTitleDescription title={title} description={description} />
        <StepCard
          title={t("prescription.button.account.title")}
          description={t("prescription.button.account.description")}
          onClick={handleFromAccount}
        />
        <StepCard
          title={t("prescription.button.manual.title")}
          description={t("prescription.button.manual.description")}
          onClick={handleManualInput}
        />
      </div>
    </StepSection>
  );
};
